import ClearIcon from "@mui/icons-material/Clear";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import IconButton from "@mui/material/IconButton";
import * as React from "react";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import shuffleArray from "shuffle-array";
import sampleSound from "../assets/sound/oSound.wav";
import "./SettingPage.css";
const SettingPage = ({ reSettingKaruta, customSetting, customHudaList, setOpen, play }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatcher = useDispatch();
    const [playTime, setPlayTime] = useState(0.0);
    const [playSample, setPlaySample] = useState(false);
    const audioRef = useRef();
    const playTimeRef = useRef();
    const [totalTime, setTotalTime] = useState(0.0);
    const [setting, setSetting] = useState(customSetting);
    const hudaList = useRef(setNewHudaList(customHudaList));
    const betweenSameIntreval = 1000;
    function valuetext(value) {
        return `${value}`;
    }

    function setCardNum(num) {
        setSetting({ ...setting, cardNum: num });
    }
    function setRepeat(num) {
        setSetting({ ...setting, repeatCount: num });
    }
    function setSpeed(time) {
        if (time === 1) {
            setSetting({ ...setting, speed: 1.2 });
        } else if (time === -1) {
            setSetting({ ...setting, speed: 0.8 });
        } else {
            setSetting({ ...setting, speed: 1 });
        }
    }
    function setInterval(mInterval) {
        setSetting({ ...setting, interval: mInterval });
    }
    React.useEffect(() => {}, []);
    React.useEffect(() => {
        if (playSample) {
            audioRef.current.playbackRate = setting.speed;
            audioRef.current.play();
        } else {
            audioRef.current.pause();
            audioRef.current.currenTime = 0;
        }
    }, [playSample, setting.speed]);
    React.useEffect(() => {
        setPlayTime(playTimeRef.current);
    }, [playTimeRef.current]);
    function setNewHudaList(list) {
        var mList = shuffleArray.pick(list, { picks: setting.cardNum });
        mList.forEach((e) => {
            var newAudio = new Audio(e.sound);
            newAudio.addEventListener("loadedmetadata", (e2) => {
                e.duration = e2.target.duration;
            });
            newAudio.remove();
            newAudio.srcObject = null;
            newAudio.src = "";
        });
        return mList;
    }
    function reSetting() {
        reSettingKaruta(setting);
        setOpen(false);
    }
    function renderingTime(time) {
        const minutes = Math.floor(time / 60);
        let seconds = Math.floor(time % 60);

        if (!(seconds / 10 >= 1)) {
            seconds = "0" + seconds;
        }
        if (seconds == 0 || seconds == "00") {
            return `${minutes}分`;
        } else {
            return `${minutes}分 ${seconds}秒`;
        }
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.1rem" }}>
            <div className="head-bar">
                <IconButton
                    onClick={() => {
                        setOpen(false);
                    }}
                >
                    <ClearIcon className="home-button" style={{ color: "rgb(247, 205, 154)" }}></ClearIcon>
                </IconButton>
            </div>
            <audio
                src={sampleSound}
                ref={audioRef}
                onEnded={() => {
                    setPlaySample(false);
                }}
            ></audio>
            <div>
                <div
                    style={{
                        width: "95%",
                        margin: "auto",
                        boxShadow: "1px 1px 1px 1px rgb(224, 219, 219)",
                        borderRadius: "5px",
                    }}
                >
                    <div style={{ padding: "1px", display: "flex" }}>
                        <FormControl sx={{ width: "100%", margin: "10px" }}>
                            <FormLabel sx={{ textAlign: "start" }} id="demo-row-radio-buttons-group-label">
                                <span style={{ fontWeight: "600" }}>遊ぶかるた枚数</span>
                            </FormLabel>

                            <div style={{ width: "100%" }}>
                                <ButtonGroup aria-label="Basic button group">
                                    <Button
                                        size="large"
                                        variant={setting.cardNum == 10 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setCardNum(10);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>10枚</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.cardNum == 25? "contained" : "outlined"}
                                        onClick={() => {
                                            setCardNum(25);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}> 25枚</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.cardNum == 46 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setCardNum(46);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}> 46枚</span>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div style={{}}>
                <div style={{ width: "95%", margin: "auto", boxShadow: "1px 1px 1px 1px rgb(224, 219, 219)", borderRadius: "5px" }}>
                    <div style={{ padding: "1px", display: "flex" }}>
                        <FormControl sx={{ width: "100%", margin: "10px" }}>
                            <FormLabel sx={{ textAlign: "start" }} id="demo-row-radio-buttons-group-label">
                                <span style={{ fontWeight: "600" }}>読む回数</span>
                            </FormLabel>
                            <div style={{ width: "100%", display: "flex" }}>
                                <ButtonGroup aria-label="Basic button group">
                                    <Button
                                        size="large"
                                        variant={setting.repeatCount == 1 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setRepeat(1);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>1回</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.repeatCount == 2 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setRepeat(2);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>2回</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.repeatCount == 3 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setRepeat(3);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}> 3回</span>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div style={{}}>
                <div style={{ width: "95%", margin: "auto", boxShadow: "1px 1px 1px 1px rgb(224, 219, 219)", borderRadius: "5px" }}>
                    <div style={{ padding: "1px", display: "flex" }}>
                        <FormControl sx={{ width: "100%", margin: "10px" }}>
                            <FormLabel sx={{ textAlign: "start" }} id="demo-row-radio-buttons-group-label">
                                <span style={{ fontWeight: "600" }}> 次の札を読むまでの間隔</span>
                            </FormLabel>
                            <div style={{ width: "100%", display: "flex" }}>
                                <ButtonGroup aria-label="Basic button group">
                                    <Button
                                        size="large"
                                        variant={setting.interval == 3 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setInterval(3);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}> 3秒</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.interval == 5 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setInterval(5);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>5秒</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.interval == 7 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setInterval(7);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>7秒</span>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </FormControl>
                    </div>
                </div>
            </div>

            <div style={{}}>
                <div style={{ width: "95%", margin: "auto", boxShadow: "1px 1px 1px 1px rgb(224, 219, 219)", borderRadius: "5px" }}>
                    <div style={{ padding: "1px", display: "flex" }}>
                        <FormControl sx={{ width: "100%", margin: "10px" }}>
                            <FormLabel sx={{ textAlign: "start", display: "flex" }} id="demo-row-radio-buttons-group-label">
                                <span style={{ fontWeight: "600" }}>再生スピード</span>
                                {!playSample ? (
                                    <PlayCircleIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setPlaySample(true);
                                        }}
                                    />
                                ) : (
                                    <StopCircleIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setPlaySample(false);
                                        }}
                                    />
                                )}
                            </FormLabel>

                            <div style={{ width: "100%", display: "flex" }}>
                                <ButtonGroup aria-label="Basic button group">
                                    <Button
                                        size="large"
                                        variant={setting.speed < 1 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setSpeed(-1);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>ゆっくり</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.speed == 1 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setSpeed(0);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>ふつう</span>
                                    </Button>
                                    <Button
                                        size="large"
                                        variant={setting.speed > 1 ? "contained" : "outlined"}
                                        onClick={() => {
                                            setSpeed(1);
                                        }}
                                    >
                                        <span style={{ fontWeight: "500" }}>はやく</span>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </FormControl>
                    </div>
                </div>
            </div>
            {/* <div>所要時間：{renderingTime(playTimeRef.current)}</div> */}

            <div style={{ margin: " 0 auto" }}>
                <Button
                    style={{ marginTop: "1rem", minWidth: "185px" }}
                    className="answer-button"
                    component="label"
                    variant="contained"
                    tabIndex={-1}
                    onClick={() => {
                        // dispatcher(buttonEffectSetTrue());
                        play();
                        reSetting();
                    }}
                    startIcon={<PlayCircleIcon style={{ fontSize: "1.5rem" }} />}
                >
                    <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>決定</span>
                </Button>
            </div>
        </div>
    );
};

export default SettingPage;
